import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/equipmentLive/pdf.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7ec88264"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "fixedInfo"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "使用说明及保养手册", -1);
});
var _hoisted_4 = [_hoisted_2, _hoisted_3];
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "电气图纸", -1);
});
var _hoisted_7 = [_hoisted_5, _hoisted_6];
var _hoisted_8 = {
  class: "info"
};
var _hoisted_9 = {
  class: "info-item"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "info-label"
  }, "设备出厂日期", -1);
});
var _hoisted_11 = {
  class: "info-value"
};
var _hoisted_12 = {
  class: "info-item"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "info-label"
  }, "设备投产日期", -1);
});
var _hoisted_14 = {
  class: "info-value"
};
var _hoisted_15 = {
  class: "info-item"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "info-label"
  }, "额定电压/V", -1);
});
var _hoisted_17 = {
  class: "info-value"
};
var _hoisted_18 = {
  class: "info-item"
};
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "info-label"
  }, "额定功率/KW", -1);
});
var _hoisted_20 = {
  class: "info-value"
};
var _hoisted_21 = {
  class: "info-item"
};
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "info-label"
  }, "额定电流/A", -1);
});
var _hoisted_23 = {
  class: "info-value"
};
var _hoisted_24 = {
  class: "info-item"
};
var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "info-label"
  }, "外形尺寸/mm", -1);
});
var _hoisted_26 = {
  class: "info-value"
};
var _hoisted_27 = {
  class: "info-item"
};
var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "info-label"
  }, "设备重量/KG", -1);
});
var _hoisted_29 = {
  class: "info-value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_title = _resolveComponent("c-title");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_c_title, {
    title: "固定信息"
  }), !_ctx.tmpShow ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", {
    class: "instruction flex align-center mb-2",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.toUsings && _ctx.toUsings.apply(_ctx, arguments);
    })
  }, _hoisted_4), _createElementVNode("div", {
    class: "instruction flex align-center mb-2",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    function () {
      return _ctx.toDarwings && _ctx.toDarwings.apply(_ctx, arguments);
    })
  }, _hoisted_7)], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.emptyStringFormat(_ctx.deviceInfo.release_date)), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.emptyStringFormat(_ctx.deviceInfo.pro_date)), 1)]), !_ctx.tmpShow ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.emptyStringFormat(_ctx.deviceInfo.rated_voltage)), 1)]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.emptyStringFormat(_ctx.deviceInfo.rated_power)), 1)]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.emptyStringFormat(_ctx.deviceInfo.rated_current)), 1)])], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.emptyStringFormat(_ctx.deviceInfo.measure)), 1)]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.emptyStringFormat(_ctx.deviceInfo.weight)), 1)])])]);
}